/** Maturity, domain grouping, and platform taxonomy shared across systems. */

export type Maturity = 'daily' | 'supported' | 'incubator' | 'admin' | 'archive';

export const MATURITIES: readonly Maturity[] = [
  'daily',
  'supported',
  'incubator',
  'admin',
  'archive',
] as const;

/** Domain groups for the system directory (All Systems). Not top-level nav. */
export type DomainGroup =
  | 'daily'
  | 'direction'
  | 'repair'
  | 'projects'
  | 'knowledge'
  | 'study'
  | 'career'
  | 'health'
  | 'finance'
  | 'business'
  | 'work'
  | 'mental'
  | 'spiritual'
  | 'environment'
  | 'assistant'
  | 'bridges'
  | 'runtime'
  | 'archive';

export const DOMAIN_GROUPS: readonly DomainGroup[] = [
  'daily',
  'direction',
  'repair',
  'projects',
  'knowledge',
  'study',
  'career',
  'health',
  'finance',
  'business',
  'work',
  'mental',
  'spiritual',
  'environment',
  'assistant',
  'bridges',
  'runtime',
  'archive',
] as const;

export type Platform = 'web' | 'linux' | 'windows' | 'android' | 'ios';

export const PLATFORMS: readonly Platform[] = ['web', 'linux', 'windows', 'android', 'ios'] as const;

export type PlatformAvailability = 'available' | 'planned' | 'not_applicable' | 'excepted';

export const PLATFORM_AVAILABILITIES: readonly PlatformAvailability[] = [
  'available',
  'planned',
  'not_applicable',
  'excepted',
] as const;

export function isMaturity(value: unknown): value is Maturity {
  return typeof value === 'string' && (MATURITIES as readonly string[]).includes(value);
}

export function isDomainGroup(value: unknown): value is DomainGroup {
  return typeof value === 'string' && (DOMAIN_GROUPS as readonly string[]).includes(value);
}
